import { useContext, useState } from 'react';
import type { Themes } from '../../contexts';
import { ThemeContext, UserContext } from '../../contexts';
import { RadioButton } from '../atoms/RadioButton';
import { withAuthRedirect } from '../hocs';
import { RadioGroup } from '../molecules';
import { Request } from '../../apis';
import { z } from 'zod';

const UserPreferences = () => {
  const { onThemeChange, theme } = useContext(ThemeContext);
  const [merchantDetails, setMerchantDetails] = useState<object>({
    keyFoo: 'valBar'
  });

  // const merchantId = useLoggedInUserStore((store) => store.merchant);
  const { user } = useContext(UserContext);
  const merchantId = user.merchantId;
  // TODO log
  //console.log('UserPreferences: merchantId', merchantId);
  const getMerchant = async () => {
    const merchant = await Request.safeGet({
      path: `merchants/${merchantId}?access_token`,
      schema: z.any()
    });
    if (merchant.type === 'right') {
      setMerchantDetails(merchant.value);
    }
  };
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newTheme = event.target.value as Themes;
    // TODO log
    //console.log('newTheme: ', newTheme);
    onThemeChange(newTheme);
  };
  return (
    <div>
      <h1>UserPreferences</h1>
      <button onClick={getMerchant}>Get Merchant Details</button>
      <div>
        <p>Merchant</p>

        {Object.entries(merchantDetails).map(([key, value]) => (
          <p>
            {key.toString()}: {value.toString()}
          </p>
        ))}
      </div>
      <RadioGroup>
        <RadioButton
          name="zeefiTheme"
          currentlySelected={theme}
          onChange={onChange}
        />
      </RadioGroup>
      <span>
        <b>Current Theme is</b>: {theme}
      </span>
    </div>
  );
};

const SecureUserPreferences = withAuthRedirect(UserPreferences);
export { SecureUserPreferences as UserPreferences };
